<template>
  <div
    class="pt-5 page-header align-items-start min-vh-50 pb-11 row"    
  >
    <span class="bg-gradient-dark opacity-6"></span>
    <div class="container">
      <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5">
          <img src="../assets/img/ToMate-black.png" alt="main_logo" style=" z-index: 1099; height: 220px; margin: -50px 0px 0px 0px;"/>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="justify-content: center;">
        <div class="mb-4 col-xl-4 col-lg-6 col-md-12 d-flex flex-column"> 
          <div class="container" style="width: fit-content;">
            <div class="card z-index-0" style="min-width: 349px">
              <div class="pb-0 card-header text-center">
                <img src="../assets/img/tick.png" height="45" width="45"/>
                  <h3 class="font-weight-bolder" style="color: #00E476;">
                    Payment succesful
                  </h3>   
              </div>
              <div class="card-body text-center">
                  <p class="mb-0">Thank you for choosing our product. We appreciate your trust in our technology.</p>
              </div>

              <div class="card-footer text-center">
                  <soft-button
                    @click="goToApp()"
                    class="mb-2"
                    style="background-color: #00E476;"
                    full-width
                    >Start generating emails
                  </soft-button>
                </div>
            </div>
          </div>
        </div>
        <div class="mb-4 col-xl-4 col-lg-6 col-md-12 d-flex flex-column"> 
          <div class="container" style="width: fit-content;">
              <img height="400" src="../assets/img/Online-Groceries-rafiki.png" />
          </div>
        </div>
      </div>
    </div>
        
  </div>
  
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
import SoftButton from "@/components/SoftButton.vue";
import { mapMutations } from "vuex";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import router from '../router/index'

export default {
  name: "SuccessPayment",
  components: {
    AppFooter,
    SoftButton
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "success-payment",
        user_id: localStorage.userId
      });
    }

    this.llamada.userInfo(this.userInfoRsp.bind(this))
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  data() {
    return {
      password: "",
      llamada: new HTFetch(),
      K: new K(),
      wrongCreds: false,
      new_password1: "",
      new_password2: ""
    }
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    goToApp() {

      router.push({name: "Sign In"})
    },

    userInfoRsp(rsp) {
      
      if (rsp.status !== 200) {
        console.log('arafue')
        return
      }
      
      if (rsp.data.manager === true) {
        localStorage.manager = 'true'
      } else {
        localStorage.manager = 'false'
      }
      if (rsp.data.inserter === true) {
        localStorage.inserter = 'true'
      } else {
        localStorage.inserter = 'false'
      } 

      localStorage.pack = rsp.data.premium
      this.plan = rsp.data.premium

      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
        collecciones.push({
          "name": Object.keys(rsp.data.collections)[i],
          "token": Object.values(rsp.data.collections)[i]
        })
      }

      localStorage.collections = JSON.stringify(collecciones)
    }
  },
};
</script>
<style scoped>
</style>
